/* 🤖 this file was generated by svg-to-ts */
export const DfIconExclamationTriangleOutline16: {
  name: 'exclamation-triangle-outline-16';
  data: string;
} = {
  name: 'exclamation-triangle-outline-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m9.788 1.107 6 11.995A2.002 2.002 0 0 1 13.996 16H2.003a2.003 2.003 0 0 1-1.792-2.897L6.203 1.108a2.004 2.004 0 0 1 3.585 0zM7.548 2.67 2.351 13.28a.5.5 0 0 0 .45.72h10.396a.5.5 0 0 0 .449-.72L8.445 2.669a.5.5 0 0 0-.898 0zM8 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1zm0 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/></svg>`
};
